module.exports = __webpack_public_path__ + "img/low_temperature_warning.0fe66899.svg";